import { render } from "./doctorImage.vue?vue&type=template&id=66b875e5&scoped=true"
import script from "./doctorImage.vue?vue&type=script&lang=js"
export * from "./doctorImage.vue?vue&type=script&lang=js"

import "./doctorImage.vue?vue&type=style&index=0&id=66b875e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b875e5"]])

export default __exports__